export default __webpack_public_path__ + "71aa85aeb585bfc1cdea5e7ce0e919f3.png";